import { toast } from "react-toastify";
import { AVISOS_STOCK_API } from "../views/MainLayout/components/shared/services/avisosStock";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialAvisos = []

export const avisosStockReducer = (state = initialAvisos, action) => {
    switch(action.type){
        case "avisos-stock/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchAvisosStock = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await AVISOS_STOCK_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'avisos-stock/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}